import Vue from 'vue'
import axios from 'axios'
import store from '@/store'

Vue.prototype.$axios = axios.create(
  {
    headers:
      {
        // 'x-api-key': 'WEB-oEvr0WhKVkxnLeSqBfLCH1d9qQV8Ab8qCHT2V1xX',
        'x-api-key': "WEB-Gsb2fOvlC3v9FSBK6Zco6ZVyNVyrPYL3IZrwNOAI",
        'Content-Type': 'application/json',
        'x-language': 'en'
      },
    baseURL: "https://api.fitenment.com/api"
    // baseURL: "https://api.test.fitenment.com/api/"
  }
);

Vue.prototype.$axios.interceptors.request.use(
  config =>
  {
    config.headers['Authorization'] = 'Bearer ' + store.state.token;
    return config;
  }
);

export default Vue.prototype.$axios
